import { FieldValues, useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';

import { FormSection } from 'common/components/FormSection';
import {
    GroupConditionExtendedFilterField,
    GroupConditionFilterField,
} from 'user/forms/Field';
import { TControllerProps } from 'common/types';

interface IProps {
    currentUserIsAuthor?: boolean;
    isWebinarOrMeeting?: boolean;
}

export const GroupConditionsSection = <TFieldValues extends FieldValues>({
    control,
    currentUserIsAuthor,
    isWebinarOrMeeting,
}: IProps & TControllerProps<TFieldValues>) => {
    const [translate] = useTranslation();
    const { errors } = useFormState();

    return (
        <FormSection
            renderExpanded
            defaultExpanded={currentUserIsAuthor}
            description={<Box>{translate('offer.groupFilterDescription')}</Box>}
            hasError={!!errors?.groupConditions}
            sx={[
                {
                    borderTop: 1,
                    borderTopColor: 'divider',
                },
            ]}
            title={translate('offer.groupFilterTitle')}
        >
            <Box sx={{ mt: 3 }}>
                {isWebinarOrMeeting ? (
                    <GroupConditionExtendedFilterField
                        control={control}
                        name="groupConditions"
                    />
                ) : (
                    <GroupConditionFilterField
                        control={control}
                        name="groupConditions"
                    />
                )}
            </Box>
        </FormSection>
    );
};
